<template>
  <div
      :class="['map', 'l2']"
      :style="{
        'width': (stepScale === 4 ? lWidth : 0) + 'px',
        'height': (stepScale === 4 ? lHeight : 0) + 'px',
        'transform': stepScale === 4 && visible ? 'translate(' + left + 'px, ' + top + 'px) scale(' + lScale + ')' : '',
        'position': stepScale === 4 ? 'absolute' : 'static',
        'will-change': stepScale === 4 && visible ? 'transform' : '',
        'display': visible ? '' : 'none'
      }"
  >
    <template v-for="item of els" :key="Math.random(item)">
      <BlockBrick
          v-if="item.type === 1"
          v-show="visible"
          :x="item.x"
          :y="item.y"
          :tx="tx"
          :ty="ty"
          :l1x="l1x"
          :l1y="l1y"
          :l2x="x"
          :l2y="y"
          :step="stepScale"
          :scale="scale"
          :cw="cw"
          :ch="ch"
          :vl="vl"
      />
      <BetonBrick
          :key="Math.random(item)"
          v-else-if="item.type === 2"
          v-show="visible"
          :x="item.x"
          :y="item.y"
          :tx="tx"
          :ty="ty"
          :l1x="l1x"
          :l1y="l1y"
          :l2x="x"
          :l2y="y"
          :step="stepScale"
          :scale="scale"
          :cw="cw"
          :ch="ch"
          :vl="vl"
      />
    </template>
  </div>
</template>

<script>
import BlockBrick from "@/components/BlockBrick";
import BetonBrick from "@/components/BetonBrick";

export default {
  name: "MapX4",
  components : { BetonBrick, BlockBrick },
  props: {
    x: Number,
    y: Number,
    width: Number,
    height: Number,
    els: Array,
    sub: Array,
    tx: Number,
    ty: Number,
    scale: Number,
    cw: Number,
    ch: Number,
    stepScale: Number,
    l1x: Number,
    l1y: Number,
    vl: Number
  },
  computed: {
    lWidth () {
      return this.width * this.stepScale;
    },
    lHeight () {
      return this.height * this.stepScale;
    },
    lScale () {
      return this.scale / this.stepScale;
    },
    left () {
      return this.x * this.scale + this.tx;
    },
    right () {
      return this.left + this.lWidth * this.scale;
    },
    top () {
      return this.y * this.scale + this.ty;
    },
    bottom () {
      return this.top + this.lHeight * this.scale;
    },
    hVisible () {
      return this.left < this.cw && this.right > 0;
    },
    vVisible () {
      return this.top < this.ch && this.bottom > 0;
    },
    visible () {
      return this.hVisible && this.vVisible;
    }
  }
}
</script>
